var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navbar-toggler BaseTogglerButton header-toggler",class:{ is_open: _vm.value }},[_c('span'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }